import { AssetType as w } from "../../../temp-lib/constants/url.js";
import P from "../../../temp-lib/hooks/generic/useApeironPathMaker.js";
import { singleOperation as A } from "../../../temp-lib/util/operation/singleOperation.js";
import E from "query-string";
import * as t from "ramda";
import * as T from "ramda-adjunct";
import { useCallback as i } from "react";
let y = {};
const _ = "fetch_json", q = () => {
  const {
    makePath: m
  } = P(), l = i((s) => {
    const n = t.pipe(t.split("::"), t.tail, t.join("/"));
    return t.concat(n(s), ".json");
  }, []), h = i((s) => `${_}_${t.replace(/\//g, "_", s)}`, []), D = i((s, n) => async () => {
    const o = m(w.Json, s);
    return (await fetch(E.stringifyUrl({
      url: o,
      query: {
        buildId: n
      }
    }), {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })).json();
  }, [m]), j = i(async (s, n, o) => {
    const e = async (r) => {
      const {
        path: c
      } = r, f = h(c), O = t.propOr(null, f, y);
      if (t.isNil(O)) {
        const g = await A(f, D(c, o));
        return y = t.assoc(f, g, y), g;
      }
      return O;
    }, p = await Promise.all(t.map(e, n));
    let a = s;
    return T.mapIndexed((r, c) => {
      const f = n[c];
      a = t.assocPath(f.locations, r, a);
    }, p), a;
  }, [h, D]), k = i((s, n, o) => {
    const e = {
      locations: n,
      path: l(o)
    };
    s.push(e);
  }, [l]), u = i(async (s, n, o = [], e = []) => {
    let p = s;
    if (t.is(Array, s))
      for (const [a, r] of s.entries())
        await u(r, n, t.append(a, o), e);
    else if (t.is(Object, s)) {
      const a = t.keys(s);
      for (const r of a) {
        const c = s[r];
        await u(c, n, t.append(r.toString(), o), e);
      }
    } else
      t.is(String, s) && t.startsWith("metadata::", s) && k(e, o, s);
    return t.isEmpty(o) && t.isNotEmpty(e) && (p = await j(p, e, n)), p;
  }, [k, j]);
  return {
    injectData: u
  };
};
export {
  q as default
};
//# sourceMappingURL=useInjectJson.js.map
